<template>
  <div>
    <header-info
      :user-data="member.influencer.user"
      :type-data="member.influencer"
      :channels="channels"
      :show-add-remove-favlist-button="true"
    />

    <nav-buttons
      :details-route="{name: 'campaign-members-member-profile-details'}"
      :audience-route="{name: 'campaign-members-member-profile-audience'}"
    />

    <transition
      name="fade"
      @before-leave="makeAbsolute"
    >
      <router-view
        :channels="channels"
        :user-data="member.influencer.user"
        :type-data="member.influencer"
      />
    </transition>
  </div>
</template>

<script>
import HeaderInfo from '../../../user-profile-partials/details-partials/HeaderInfo.vue'
import NavButtons from '../../../user-profile-partials/details-partials/NavButtons.vue'

export default {
  components: {
    'header-info': HeaderInfo,
    'nav-buttons': NavButtons
  },
  props: {
    campaign: {
      type: Object,
      default: () => { return {} }
    },
    member: {
      type: Object,
      default: () => { return {} }
    }
  },
  computed: {
    channels () {
      return this.member.influencer.channels || []
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
